import { object, string, email } from "yup"

import BusinessInfo from "./views/BusinessInfo"
import AdditionalDocuments from "./views/AdditionalDocuments"
import Updates from "./views/Updates"

export default [
  {
    id: "business_info",
    component: BusinessInfo,
    initialValues: {
      business_name: "",
      bn_rc_number: "",
      tin: "",
      registration_date: "",
      business_address: "",
    },
    validationSchema: object().shape({
      business_name: string().required("Type in  your Business Name"),
      registration_date: string().required("Required"),
      business_address: string().required("Required"),
      bn_rc_number: string()
        .required("BN/RC Number is required")
        .min(9, "Invalid BN/RC Number")
        .max(9, "Invalid BN/RC Number"),
      tin: string()
        .required("TIN is required")
        .min(10, "Invalid TIN")
        .max(13, "Invalid TIN"),
    }),
    actionLabel: "Next",
  },
  {
    id: "additional_documents",
    component: AdditionalDocuments,
    initialValues: {
      certificate_of_registration: "",
      certificate_of_registration_name: "",
    },
    validationSchema: object().shape({
      // certificate_of_registration: string().required("A file is required"),
    }),
    actionLabel: "Continue",
  },
  {
    id: "updates",
    component: Updates,
    initialValues: {
      new_email: "",
      new_phone: "",
    },
    validationSchema: object().shape({
      new_email: string()
        .email("Must be a valid email address")
        .required("Add a new Email"),
      new_phone: string()
        .matches(/^[0-9]{11}$/, "This phone number is Invalid")
        .required("Required"),
    }),
    actionLabel: "Confirm",
  },
]
